const motionSensitivity = {
  MD_HIGH: {
    diffThreshold: 15,
    contourAreaThreshold: 0,
    motionDuration: 1500
  },
  MD_MEDIUM: {
    diffThreshold: 25,
    contourAreaThreshold: 0.01,
    motionDuration: 1500
  },
  MD_LOW: {
    diffThreshold: 35,
    contourAreaThreshold: 0.05,
    motionDuration: 1500
  },
  MD_OFF: "OFF"
};

const averageThresholds = {
  MD_HIGH: 0.005,
  MD_MEDIUM: 0.01,
  MD_LOW: 0.05
};

const motionStringKeys = {
  MD_HIGH: "noiseSensitivity.level.high",
  MD_MEDIUM: "noiseSensitivity.level.medium",
  MD_LOW: "noiseSensitivity.level.low",
  MD_OFF: "motionDetection.off"
};

export default motionSensitivity;
export { motionStringKeys, averageThresholds };
